import { render, staticRenderFns } from "./EquivalenceDetailing.vue?vue&type=template&id=0a064d50&scoped=true&"
import script from "./EquivalenceDetailing.vue?vue&type=script&lang=ts&"
export * from "./EquivalenceDetailing.vue?vue&type=script&lang=ts&"
import style0 from "./EquivalenceDetailing.vue?vue&type=style&index=0&id=0a064d50&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a064d50",
  null
  
)

export default component.exports